module.exports = __webpack_public_path__ + "img/straight-big-line.aa9041f6.svg";